import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import SignUp from './pages/SignUp';
// import SignIn from './pages/SignIn';
import Dashboard from './pages/Dashboard'; // Changed this line
import ChatWidget from './components/ChatWidget';
import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Affiliate from './pages/Affiliate';
import NotFound from './pages/NotFound';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>; // Or your loading component
  }
  
  if (!user) {
    return <Navigate to="/signup" />;
  }
  
  return children;
};

// Create a new component for the app content
function AppContent() {
  const { user, loading } = useAuth();

  // If user is authenticated, redirect to dashboard from public routes
  const PublicRoute = ({ children }) => {
    if (!loading && user) {
      return <Navigate to="/dashboard" />;
    }
    return children;
  };
  
  return (
    <Router>
      <div className="min-h-screen bg-black text-white">
        <Routes>
          <Route path="/" element={
            <PublicRoute>
              <SignUp />
            </PublicRoute>
          } />
          <Route path="/signup" element={
            <PublicRoute>
              <SignUp />
            </PublicRoute>
          } />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/affiliate" element={<Affiliate />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ChatWidget />
      </div>
    </Router>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
